import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  questionColumns,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useStore } from "../../hooks/store";
import { getQuestion, deleteQuestion } from "../../utils/API/questionMethods";
import QuestionForm from "../Form/QuestionForm/QuestionForm";
import { getThemeToQuestion } from "../../utils/API/themeMethods";
import { getAnswer } from "../../utils/API/answerMethods";
import GridToolBar from "../GridToolBar";

export function QuestionGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [questionData, setQuestionData] = useState(undefined);

  const fetchQuestionData = () => {
    getQuestion().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    store.setForm(<QuestionForm />, fetchQuestionData);
  };

  const handleRedactOpener = async () => {
    const { data: answers } = await getAnswer(questionData.id);
    const { data: themes } = await getThemeToQuestion(questionData.id);
    store.setForm(<QuestionForm />, fetchQuestionData, {
      ...questionData,
      answers: answers,
      themes: themes,
    });
  };

  const handleDelete = async () => {
    const { id } = questionData;

    await deleteQuestion(id);
    await fetchQuestionData();
    return;
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchQuestionData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setQuestionData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchQuestionData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={questionData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...questionColumns]}
      />
    </div>
  );
}
